import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-10 w-full rounded-xl border border-[rgba(37,99,235,0.16)] bg-white/70 backdrop-blur-sm px-3.5 py-1 text-base shadow-[0_1px_2px_rgba(23,37,84,0.04)] transition-all duration-200 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-[#94A3B8] hover:border-[rgba(56,189,248,0.55)] focus-visible:outline-none focus-visible:border-brand-sky focus-visible:ring-4 focus-visible:ring-brand-sky/20 focus-visible:bg-white disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
